// @core/api/endpoints/task/resolve_task_context.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResolveTaskContextRequest,
  ResolveTaskContextResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Resolve task context
 * Resolves the effective task management policy for a scope entity by merging the policy hierarchy. Returns merged policy, available templates, numbering schemes, and allowed task types.
 */
export async function ResolveTaskContext(
  data: ResolveTaskContextRequest,
  options?: RequestOptions
): Promise<ResolveTaskContextResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks/resolve-context`;
  const requestOptions = options;
  return client.post<ResolveTaskContextResponse>(requestPath, data, requestOptions);
}
